var map = {
	"./add-answer.svg": "23a7",
	"./amplifon-logo-mini.svg": "664f",
	"./amplifon-logo.svg": "ece0",
	"./arrow.svg": "21e2",
	"./bulleted-list.svg": "8007",
	"./check.svg": "7bae",
	"./checkbox-marked.svg": "8441",
	"./checkbox.svg": "5b02",
	"./close-white.svg": "72e4",
	"./contact-support.svg": "e4a1",
	"./copy.svg": "8aac",
	"./countries.svg": "71bc",
	"./cross.svg": "2ad7",
	"./delete-active.svg": "e58a",
	"./delete-white.svg": "744f",
	"./delete.svg": "0d45",
	"./dismiss.svg": "ecf9",
	"./document-plus.svg": "48d2",
	"./down.svg": "d8aa",
	"./drag-icon.svg": "1f8a",
	"./drawer/arrow-menu-white.svg": "80be",
	"./drawer/arrow-menu.svg": "5f63",
	"./drawer/contents-white.svg": "04b8",
	"./drawer/contents.svg": "06f1",
	"./drawer/dashboard-white.svg": "0a1d",
	"./drawer/dashboard.svg": "f552",
	"./drawer/expanded-menu.svg": "cf5f",
	"./drawer/leaderboard-white.svg": "04ed",
	"./drawer/leaderboard.svg": "5c9a",
	"./drawer/logs-white.svg": "7265",
	"./drawer/logs.svg": "4af0",
	"./drawer/map-white.svg": "287e",
	"./drawer/map.svg": "8588",
	"./drawer/news-white.svg": "6e29",
	"./drawer/news.svg": "ae2f",
	"./drawer/school-news-white.svg": "8290",
	"./drawer/school-news.svg": "d04f",
	"./drawer/school-project-white.svg": "9b65",
	"./drawer/school-project.svg": "eb04",
	"./drawer/users-white.svg": "5fe6",
	"./drawer/users.svg": "9523",
	"./envelope/envelope-active.svg": "c598",
	"./envelope/envelope.svg": "9d5b",
	"./expand-map.svg": "62dd",
	"./eye-block/eye-active.svg": "9e77",
	"./eye-block/eye.svg": "de0b",
	"./eye/eye-active.svg": "0ac4",
	"./eye/eye.svg": "46dd",
	"./filter.svg": "2376",
	"./forms/call-icon.svg": "acd1",
	"./forms/email-icon.svg": "6590",
	"./forms/info-client-icon.svg": "4668",
	"./forms/lock-icon.svg": "b222",
	"./full-screen-red.svg": "9441",
	"./full-screen.svg": "76af",
	"./localization-pointer.svg": "68b6",
	"./lock/lock-active.svg": "a75b",
	"./lock/lock.svg": "4c43",
	"./lr-logo-mini.svg": "e559",
	"./lr-logo.svg": "d518",
	"./measurement.svg": "6d49",
	"./minus.svg": "3e24",
	"./plus.svg": "eb38",
	"./pointer_map.svg": "2c9c",
	"./refresh.svg": "53fa",
	"./reset.svg": "c680",
	"./school-project-active.svg": "4eca",
	"./search-icon.svg": "7669",
	"./sort-table-col.svg": "065f",
	"./standard-screen.svg": "3489",
	"./text-editor/bullet-list-white.svg": "899c",
	"./text-editor/bullet-list.svg": "d1b4",
	"./text-editor/link-white.svg": "f29f",
	"./text-editor/link.svg": "4571",
	"./up.svg": "5c5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";